import {useEffect, useState} from 'react';
import {Box, useMediaQuery} from '@mui/material';
import Loader from '@/shared/components/Loader';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import CheckOutTable from '@/components/Organization/CheckOut/CheckoutTable';
import {auctionStyle} from '../Auction/Auction.styles';
import {toast} from 'react-toastify';
import {getErrorMessage} from '@/utils/helpers';
import {getAuctionCategories} from '@/store/organization-auction';
import {getCurrentEventSelector, getEventsSelector} from '@/store/organization-event';
import {getAttendeesList} from '@/store/organization-attendees';
import {defaultPageSize} from '@/utils/constants';
import EmptyContent from '@/shared/components/Table/EmptyContent';
import {ReactComponent as PeopleIcon} from '@/assets/icons/sidebar/people.svg';
import {style} from './CheckoutStyle.styles';
import {orgAPI} from '@/core/api';

const CheckOut = () => {
	const dispatch = useAppDispatch();
	const isLaptop = useMediaQuery('(min-width:1200px)');

	const events = useAppSelector(getEventsSelector);
	const event = useAppSelector(getCurrentEventSelector);

	const [isDataLoaded, setIsDataLoaded] = useState(false);

	const getAuctionListData = async () => {
		setIsDataLoaded(false);
		try {
			const reqBody = {
				eventId: event?.id as number,
				page: 1,
				pageSize: isLaptop ? defaultPageSize : 10000,
				hasContribution: true,
			};

			await Promise.all([
				dispatch(getAttendeesList(reqBody)).unwrap(),
				dispatch(getAuctionCategories(orgAPI)).unwrap(),
			]);
		} catch (error) {
			toast.error(getErrorMessage(error));
		} finally {
			setIsDataLoaded(true);
		}
	};

	useEffect(() => {
		if (!event?.id) {
			if (events && !events.length) setIsDataLoaded(true);
			return;
		}

		if (event?.id) getAuctionListData();
	}, [event?.id]);

	return (
		<Box sx={style.containerWrapper}>
			{isDataLoaded ? (
				events?.length && event ? (
					<CheckOutTable isDataLoaded={isDataLoaded} />
				) : (
					<EmptyContent title="You do not have any attendees." icon={PeopleIcon} />
				)
			) : (
				<Loader parentClassName={auctionStyle.loader} size={50} />
			)}
		</Box>
	);
};

export default CheckOut;
